export default "__VITE_ASSET__fc09fbe3__"